import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { getTheme } from 'components/theme/kyronTheme';
import { useGetLessonCollection } from 'controllers/react-query/lessonCollectionHooks';
import { LessonCollection } from 'controllers/types';
import React from 'react';
import { Outlet, useOutletContext, useParams } from 'react-router-dom';

type ContextType = {
  lessonCollection: LessonCollection;
};

export function LessonLayout() {
  const { lessonCollectionId } = useParams();
  const { data: lessonCollection, isLoading, isError } = useGetLessonCollection(Number(lessonCollectionId));

  if (isLoading) return <div data-testid='lesson-collection-loading'>Loading...</div>;

  if (isError) throw new Error('An error occurred while fetching the lesson.');

  if (!lessonCollection) throw new Error('Lesson not found.');

  // TODO: Replace with an actual layout
  return (
    <ThemeProvider theme={getTheme('dark')}>
      <CssBaseline enableColorScheme />
      <div data-testid='lesson-collection-layout'>
        <Outlet context={{ lessonCollection } satisfies ContextType} />
      </div>
    </ThemeProvider>
  );
}

export function useLessonCollection() {
  return useOutletContext<ContextType>();
}
